// lib/store/slices/experienceSlice.ts
import { createGenericSlice } from './genericSliceFactory';
import type { Experience } from '@/types';

const experienceSlice = createGenericSlice<Experience>({
    name: 'experiences',
    endpoint: '/experiences',
});

export const {
    setCurrentItem: setCurrentExperience,
    clearError,
    setSelectedIds,
    toggleSelectId,
    clearSelectedIds,
} = experienceSlice.actions;

export const {
    fetchActive: fetchActiveExperiences,
} = experienceSlice.thunks;

export default experienceSlice.reducer;
